import { useNavigate } from 'react-router';
import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';
import './cta.scss';
import { urls } from '../model';
import { ctaList } from './ctaModel';

export const GotoPrivateProducts = (props: { title?: string }) => {
	const { title } = props;
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.private);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={title || ctaList.PRIVATE}
			></ButtonComponent>
		</div>
	);
};

export const GotoCleanLabelProducts = (props: { title?: string }) => {
	const { title } = props;
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.cleanLabel);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={title || ctaList.CLEAN_LABEL}
			></ButtonComponent>
		</div>
	);
};

export const GotoNextyProducts = () => {
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.nexty);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={ctaList.NEXTY}
			></ButtonComponent>
		</div>
	);
};

export const GotoNewtoMarketProducts = () => {
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.newtoMarket);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={ctaList.NEW_TO_MARKET}
			></ButtonComponent>
		</div>
	);
};

export const GotoMinorityProducts = () => {
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.minorityOwned);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={ctaList.MINORTITY_OWNED}
			></ButtonComponent>
		</div>
	);
};

export const GotoKehe = () => {
	const navigate = useNavigate();
	return (
		<div className='cta'>
			<ButtonComponent
				onClick={() => {
					navigate(urls.kehe);
					window.scrollTo(0, 0);
				}}
				style='rounded-button secondary'
				icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				text={ctaList.KEHE}
			></ButtonComponent>
		</div>
	);
};
